import { Component, OnInit, ChangeDetectorRef, ɵConsole } from '@angular/core';
import { Design } from '../designTest/designTest.model';
import { FormGroup, FormControl, FormBuilder, Validators, NgForm } from '@angular/forms';
import { AuthenticationService, Item, TestData, Category, Complexity, Type, Style } from '../services/authentication.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MediaMatcher } from '@angular/cdk/layout';
import { TestSchedulerService } from '../services/test_scheduler.service';
import { QuestionSetService, GenerateSet } from '../services/questionset.service';
import { DesignSet, QuestionType } from '../edit-questionset/edit-questionset.model';
import { promise } from 'protractor';
import Swal from 'sweetalert2';


@Component({
  templateUrl: './generateset.component.html',
  styleUrls: [ './generateset.component.scss' ]
})

export class GenerateSetComponent {
  selectedCategory;
  selectedCategoryindex: string;
  fieldArray = [];
  categoryName: Array<Design> = [];
  typeName: Array<Design> = [];
  complexityName: Array<Design> = [];
  newAttribute: any = {};
  fieldArray1: any = {};
  setname;
  setid;
  questiontypelist = [];
  No_of_Candidates;
  Unique_or_NonUnique;
  categoryid;
  typeid;
  activate: boolean;
  complexityid;
  typelist = [];
  count;
  duration;
  Question_Category: any;
  result: boolean;
  details: boolean;
  result1;
  length;
  Category;
  Type;
  Question_Type;
  Complexity;
  complexityId: string;
  fname;
  lname;
  user;
  id;
  scheduletest: boolean;
  userAdmin: boolean;
  userSuperAdmin: boolean;
  userTestScheduler: boolean;
  userTestTaker: boolean;
  questionset: boolean;
  overall: boolean;
  mobileQuery: MediaQueryList;
  evaluate: boolean;
  private _mobileQueryListener: () => void;
  category: Category = {
    category_name: ''
  };
  type: Type = {
    cate_id:'',
    subcategory_id: '',
    style_id:''
  };
  complexity: Complexity = {
    cate_id:'',
    subcategory_id: '',
    type_id:''
  };

  style: Style = {
    cate_id: '',
    subcategory_id: ''
  }

  checked: boolean = false;
  test: TestData = {
    id: '',
    FirstName: '',
    LastName: '',
    Email: '',
    Phone: '',
    Type: ''
  };

  designTest = new FormGroup({
    questionsetname: new FormControl(''),
    category: new FormControl(''),
    type: new FormControl(''),
    complexity: new FormControl(''),
    count: new FormControl('')
  });

  generateset: GenerateSet = {
    Question_Set_Id: '',
    Question_Set_Name: ''
  };

  myForm: FormGroup;
  userEvaluator: boolean;



  constructor(private fb: FormBuilder, private auth: AuthenticationService, private router: Router,  private route: ActivatedRoute,
              private testschedulerservice: TestSchedulerService, changeDetectorRef: ChangeDetectorRef,
              media: MediaMatcher, private qs: QuestionSetService) {

    this.simpletest();
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.createForm();
  }



  ngOnInit() {
    this.getTempRowData();

    this.route.params.subscribe(params => {
      this.id = params['id'];

    this.getAccess()
  });

    this.generate();

  }


  getAccess(){
    this.user = sessionStorage.getItem('user');
    this.fname = sessionStorage.getItem('fname');

    this.lname = sessionStorage.getItem('lname');


    if (this.user === '1') {
      this.userAdmin = true;
      this.userTestScheduler = false;
      this.userEvaluator = false;
    } else if (this.user === '2') {
      this.userEvaluator = true;
      this.userAdmin = false;
      this.userTestScheduler = false;
    } else if (this.user === '3') {
      this.userTestScheduler = true;
      this.userAdmin = false;
      this.userEvaluator = false;  
    }
  }


  createForm() {
    this.myForm = this.fb.group({
       questionsetname: ['', Validators.required ],
    });
  }



selectChangeHandler(event: any, i: any) {

         this.selectedCategoryindex = i;

         this.selectedCategory = event.target.value;


         this.auth.type(this.type).subscribe(
                  (data) => {

                   this.Type = data.results;


                   this.fieldArray[i].typelist = this.Type.filter((t: any) => t.Id === +this.selectedCategory);

                  },
                        err => {
                          console.error(err);
                        }
                  );
          }

  getTempRowData() {
    this.newAttribute = { question_set_id: '', questionsetname: '', No_of_Candidates: '', Unique_or_NonUnique: '',
                          category: '', type: '', typelist: [], typelistshow: true, complexity: '', count: '' };

  }

simpletest() {
  this.testschedulerservice.test_scheduler(this.test).subscribe(
  (data) => {

   this.user = sessionStorage.getItem('user');
   this.fname = sessionStorage.getItem('fname');

   this.lname = sessionStorage.getItem('lname');


   if (this.user === '2') {

    this.userAdmin = false;
    this.userSuperAdmin = false;
    this.userTestScheduler = true;
    this.userTestTaker = true;
    this.details = true;
    this.questionset = true;
    this.scheduletest = true;
    this.overall = true;
    this.evaluate = true;
    this.result = data.results;
    return this.result;
   } else if ( this.user === '1') {
    this.userAdmin = true;
    this.userSuperAdmin = true;
    this.userTestScheduler = true;
    this.userTestTaker = true;
    this.questionset = true;
    this.details = true;
    this.scheduletest = true;
    this.overall = true;
    this.evaluate = true;
    this.result = data.results;
    return this.result;
   } else if ( this.user === '3') {
    this.userAdmin = false;
    this.userSuperAdmin = false;
    this.userTestScheduler = false;
    this.userTestTaker = true;
    this.questionset = true;
    this.overall = true;
    this.scheduletest = true;
    this.evaluate = true;
    this.details = true;
   } else if ( this.user === '4') {
    this.userAdmin = false;
    this.userSuperAdmin = false;
    this.userTestScheduler = false;
    this.userTestTaker = false;
    this.questionset = false;
    this.scheduletest = false;
    this.overall = false;
    this.evaluate = false;
    this.details = false;
   }
  },
  err => {
    console.error(err);
  }
);
}


async generate() {
  this.qs.edit(this.id).subscribe(
  async (data) => {



    this.result1 = data.results;


    for (var i = 0 ; i < this.result1.length ; i++) {
        this.setid = this.result1[i].question_set_id;
        this.setname = this.result1[i].question_set_name;
        this.No_of_Candidates = this.result1[i].No_of_Candidates;
        this.Unique_or_NonUnique = this.result1[i].Unique_or_NonUnique;
        this.categoryid = this.result1[i].Category_Name;
        this.typeid = (this.result1[i].Name);
        this.complexityid = this.result1[i].Complexity_Name;
        this.count = this.result1[i].Count;
        this.duration = this.result1[i].Duration;

        var arr:DesignSet = {
              question_set_id: this.setid ,
              questionsetname: this.setname ,
             // No_of_Candidates: this.No_of_Candidates,
              Unique_or_NonUnique: this.Unique_or_NonUnique,
              category: this.categoryid,
              type: this.typeid,
              complexity: this.complexityid,
              count: this.count,
              duration: this.duration,
              typelist: [] ,
              typelistshow: true
            };
        this.fieldArray.push(arr);
    }

   });
}

// disabledAgreement: boolean = true;

// changeCheck(event) {
//   this.disabledAgreement = !event.checked;
// }

generateSet() {

  this.qs.generateSet(this.fieldArray).subscribe(
    (data) => {

      if (data.code === 200) {
         
        Swal.fire({
          title: 'Success',
          text: data.success,
          icon: 'success',
          showCancelButton: false,
          confirmButtonText: 'OK'
        }).then((result) => {
          if (result.isConfirmed) {
            this.router.navigateByUrl('/question_set');
          }
        })
      } else {

    }
    },
    err => {
      console.error(err);
    }
  );
}
}
